/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function BadgeVerified({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#BadgeVerified_svg__a)"><path fill="currentColor" fillRule="evenodd" d="m8.52 1.674.764.652a3.2 3.2 0 0 0 1.82.754l1.002.08a.8.8 0 0 1 .733.734l.08 1a3.2 3.2 0 0 0 .755 1.822l.651.764a.8.8 0 0 1 0 1.038l-.651.765a3.2 3.2 0 0 0-.755 1.82l-.08 1.002a.8.8 0 0 1-.733.733l-1.002.08a3.2 3.2 0 0 0-1.82.755l-.765.651a.8.8 0 0 1-1.038 0l-.764-.651a3.2 3.2 0 0 0-1.821-.755l-1.001-.08a.8.8 0 0 1-.734-.733l-.08-1.001a3.2 3.2 0 0 0-.754-1.821l-.652-.765a.8.8 0 0 1 0-1.038l.652-.764a3.2 3.2 0 0 0 .754-1.821l.08-1.001a.8.8 0 0 1 .734-.734l1-.08a3.2 3.2 0 0 0 1.822-.754l.764-.652a.8.8 0 0 1 1.038 0ZM6.702.761a2 2 0 0 1 2.594 0l.765.651a2 2 0 0 0 1.138.472l1.001.08a2 2 0 0 1 1.835 1.834l.08 1.001a2 2 0 0 0 .471 1.139l.652.764a2 2 0 0 1 0 2.594l-.652.765a2 2 0 0 0-.471 1.138l-.08 1.001a2 2 0 0 1-1.835 1.835l-1.001.08a2 2 0 0 0-1.138.471l-.765.652a2 2 0 0 1-2.594 0l-.764-.652a2 2 0 0 0-1.139-.471l-1-.08A2 2 0 0 1 1.964 12.2l-.08-1.001a2 2 0 0 0-.472-1.138l-.651-.765a2 2 0 0 1 0-2.594l.651-.764a2 2 0 0 0 .472-1.139l.08-1a2 2 0 0 1 1.834-1.835l1.001-.08a2 2 0 0 0 1.139-.472l.764-.651Zm4.73 6.155a.6.6 0 0 0-.865-.833L7.121 9.658 5.41 8.06a.6.6 0 0 0-.82.877l2.144 2a.6.6 0 0 0 .841-.022l3.857-4Z" clipRule="evenodd" /></g><defs><clipPath id="BadgeVerified_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;